// Components
import { Button } from '@tracklib/kit'
import { Form, Input, TextArea, Switch, Select, baseFormValidation, ImageInput } from 'components/form'
import { Avatar } from 'kit'

// Types
import { Profile, Country } from 'types'

import styles from './profileform.css'

type ProfileFormProps = {
  onSubmit: (data: Partial<Profile>) => Promise<Record<string, unknown>>
  countryOptions: Array<Country>
  profile: Profile
}

const ProfileForm = (props: ProfileFormProps) => {
  const { countryOptions, onSubmit, profile } = props
  return (
    <Form
      enableReinitialize
      validate={baseFormValidation({
        required: { fields: ['alias'] },
        onlyLettersAndNumbers: { fields: ['alias'] },
        length: {
          fields: ['alias'],
          options: [null, 30],
          message: 'Please limit your username to 30 characters',
        },
      })}
      initialValues={{
        alias: profile.alias,
        company_name: profile.company_name,
        phone_number: profile.phone_number,
        full_name: profile.full_name,
        country: profile.country,
        description: profile.description,
        address: profile.address,
        show_prices_with_vat: profile.show_prices_with_vat,
        theme: profile.theme,
      }}
      onSubmit={onSubmit}
    >
      {({ submitButtonProps, setFieldValue }) => (
        <>
          <div className={styles.grid}>
            <Input
              name="alias"
              label="Username"
              type="text"
              placeholder="The name that will be visible to other users"
              autoComplete="username"
            />
            <Input
              name="company_name"
              label="Company name"
              type="text"
              placeholder="Your company legal name"
              optional
              autoComplete="organization"
            />
            <Input
              name="full_name"
              label="Full name"
              type="text"
              className="licenseField"
              placeholder="Your full legal name"
              optional
              autoComplete="name"
            />
            <Select
              name="country"
              id="country"
              options={countryOptions.map(x => ({ id: x.id, label: x.country_name }))}
              placeholder="Select your country"
              label="Country"
              autoComplete="country-name"
            />
            <TextArea
              name="description"
              label="Profile description"
              placeholder="A description of you that will be visible to other users"
              optional
              minRows={2}
            />
            <TextArea
              name="address"
              label="Address"
              placeholder="Postal address"
              className="licenseField"
              optional
              minRows={2}
              autoComplete="street-address"
            />
            <Select
              name="theme"
              id="theme"
              options={[
                { id: 'light', label: 'Light' },
                { id: 'dark', label: 'Dark' },
                { id: 'automatic', label: 'Automatic' },
              ]}
              label="Theme"
            />
            <Input name="phone_number" label="Phone number" type="tel" optional autoComplete="tel" />
            <div>
              <span datatesting="avatar_url" id={profile.avatar} />
              <ImageInput
                label="Profile image"
                optional
                onChange={setFieldValue}
                name="avatar"
                labelClassName={styles.avatar}
                currentImage={profile.avatar ? <Avatar className={styles.avatar} disabled sizes="80px" /> : null}
              />
            </div>
            <Switch name="show_prices_with_vat" label="Show prices with VAT" />
          </div>
          <footer>
            <Button datatesting="button_save_profile_form" className="saveBtn" {...submitButtonProps}>
              Save changes
            </Button>
          </footer>
        </>
      )}
    </Form>
  )
}

export default ProfileForm
